import { IrzFacility } from './../../../models';
import * as Yup from 'yup';
import { StepFacilityForm } from './step-facility-types';

export const stepFacilitySchema = () =>
  Yup.object<StepFacilityForm>().shape({
    facility: Yup.mixed<IrzFacility>().nullable().required('Povinné pole'),
  });
